import React from 'react';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { Problem } from './components/Problem';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
interface AppProps {
  showUrgency?: boolean;
  showPurchaseNotifications?: boolean;
}
export function App({
  showUrgency = true,
  showPurchaseNotifications = true
}: AppProps) {
  return <div className="w-full bg-white" data-id="element-0" data-mp="28sutgkvsztko">
      <main data-id="element-1" data-mp="23vck4tdvjcc5">
        <Hero data-id="element-2" data-mp="23vkzqt1dsvr1" />
        <ProofBar data-id="element-3" data-mp="23w4drynwuzzs" />
        <Problem data-id="element-4" data-mp="23ujlkfp2jt53" />
        <WhatYouGet data-id="element-5" data-mp="23v2tr4ox335x" />
        <Bonuses data-id="element-6" data-mp="23ti5fwt74ggi" />
        <Pricing showUrgency={showUrgency} data-id="element-7" data-mp="3ik7jmqgv0tve" />
        <Testimonials data-id="element-8" data-mp="3ijfvg0pldyf5" />
        <Guarantee data-id="element-9" data-mp="3ii4t85bsoyq5" />
        <Faq data-id="element-10" data-mp="3mlavl1vse5rc" />
        <CostOfInaction data-id="element-11" data-mp="3ml17xky7saot" />
        <FinalCta showUrgency={showUrgency} data-id="element-12" data-mp="3mk85gw6ag7ch" />
      </main>
      <Footer data-id="element-13" data-mp="3rcj7q5oi4587" />
      {showPurchaseNotifications && <PurchaseToast data-id="element-14" data-mp="3rcsy3udgkeef" />}
    </div>;
}